var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageQueries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C4.5101e-07 7.16344 7.16344 4.5098e-07 16 0Z",
    fill: "#FEF5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12.9689L14.8803 16.9412C14.9543 16.984 15.032 17.0149 15.1111 17.0345V24.7386L8.4907 20.8206C8.18655 20.6406 8 20.3135 8 19.96V12.9689ZM24 12.8633V19.96C24 20.3135 23.8135 20.6406 23.5093 20.8206L16.8889 24.7386V16.967C16.9051 16.9589 16.9211 16.9503 16.9369 16.9412L24 12.8633Z",
    fill: "#F59E0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.499209,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21606 11.0408C8.3001 10.9347 8.40618 10.845 8.52985 10.7791L15.5298 7.05074C15.8237 6.89422 16.1762 6.89422 16.47 7.05074L23.47 10.7791C23.5654 10.8299 23.6503 10.8948 23.7226 10.9705L16.0479 15.4015C15.9974 15.4307 15.9509 15.464 15.9085 15.5008C15.8661 15.464 15.8196 15.4307 15.7691 15.4015L8.21606 11.0408Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageQueries);
export default __webpack_public_path__ + "static/media/Manage-Queries.3c94798e282b92118d1b74dabbe8c272.svg";
export { ForwardRef as ReactComponent };